import styled from 'styled-components';
import { pxToRem } from 'utils/convert';
import { spacing } from 'ui/theme';
import { Skeleton } from 'ui/skeleton';
import { TableWrapper } from './TableWrapper';

const StyledSkeleton = styled(Skeleton)`
  height: ${pxToRem(44)};
  min-width: ${spacing.double};
`;

export const AUDIENCE_COUNTS_SKELETON_DATA_TEST = 'audience-counts-table-skeleton';

export const AudienceCountsTableSkeleton = () => (
  <TableWrapper data-test={AUDIENCE_COUNTS_SKELETON_DATA_TEST}>
    <StyledSkeleton />
  </TableWrapper>
);
